
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_44910","data-name":"Group 44910","xmlns":"http://www.w3.org/2000/svg","width":"14.222","height":"14.222"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"Rectangle_15041","data-name":"Rectangle 15041","width":"14.012","height":"14.222","transform":"translate(.104)","fill":"none"}}),_c('path',{attrs:{"id":"Path_30602","data-name":"Path 30602","d":"M3.547 5.435A2.794 2.794 0 116.336 8.27a2.814 2.814 0 01-2.789-2.835zm6.6 1.546A2.286 2.286 0 1112.436 9.3a2.3 2.3 0 01-2.287-2.319zM1.5 13.712a4.862 4.862 0 014.826-4.9 4.862 4.862 0 014.826 4.9v.082H1.5zm10.667 0h3.409c.168-.084.142-.186.142-.375a3.365 3.365 0 00-1.471-2.937 3.26 3.26 0 00-3.24-.236 5.959 5.959 0 011.161 3.55z","transform":"translate(-1.5 -1.263)","fill":"#727996"}})])
          )
        }
      }
    